import { FontAwesomeIcon } from '@/components/Common/FontAwesomeIcon/FontAwesomeIcon';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useTranslate } from '@/hooks/useTranslate';
import { cn } from '@/utils/cn';
import { useDetailsContentColor, useHasDetailsBackground } from '@/hooks/useDetailsContentColor';

type PromoCodeTriggerProps = {
  containerClassName: string;
  onExpand: () => void;
};

export const PromoCodeTrigger = ({ containerClassName, onExpand }: PromoCodeTriggerProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslate();
  const hasBackground = useHasDetailsBackground();
  const detailsColorFromHook = useDetailsContentColor();
  const triggerClass = cn('flex items-center gap-2 text-sm font-medium cursor-pointer ');

  return (
    <div data-testid="promo-code-section" className={containerClassName}>
      <button
        type="button"
        data-testid="promo-code-trigger"
        onClick={onExpand}
        className={triggerClass}
        style={detailsColorFromHook}
      >
        <FontAwesomeIcon
          icon="fa-regular fa-tag"
          className="text-muted-foreground"
          style={!isMobile ? detailsColorFromHook : undefined}
        />
        <div
          className={cn('text-sm font-medium text-card-foreground underline font-semibold text-blue')}
          style={!isMobile && hasBackground ? detailsColorFromHook : undefined}
        >
          {t('addPromoCode')}
        </div>
      </button>
    </div>
  );
};
